import React, { useState, useEffect, useLayoutEffect, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ProjectDetailsNew.css';
import { useNavigate } from 'react-router-dom';
import LazyImage from '../../LazyImage';
import { useTranslation } from '../../contexts/TranslationContext';
import projectsDataIndex from '../../data/projectsData/index.json';

// Import des images et vidéos

import LAMU_2 from '../../assets/portfoliomain/details/lamu/lamu_2.jpg';
import MOB from '../../assets/portfoliomain/dubbing_animation.webp';
import YUREI1 from '../../assets/portfoliomain/details/M2/yurei_bg_illustr.webp';
import YUREI2 from '../../assets/portfoliomain/details/M2/yurei_gameplay_illustr.webp';

const ProjectDetails = ({ restoreScrollPosition, setShowOverlay }) => {
  const { t, language } = useTranslation();
  const { projectId } = useParams();

  const [projectData, setProjectData] = useState(null);

const scrollToTop = React.useCallback(() => {
  // Désactiver le focus
  if (document.activeElement && typeof document.activeElement.blur === 'function') {
    document.activeElement.blur();
  }

  // Forcer le scroll immédiat
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  
  // Scroll sur l'élément root s'il existe
  const rootEl = document.getElementById('root');
  if (rootEl) {
    rootEl.scrollTop = 0;
  }
}, []);
  useEffect(() => {
    let isMounted = true;
    const config = projectsDataIndex && projectsDataIndex.projects ? projectsDataIndex.projects[projectId] : null;

    if (!config || !config.dataFile) {
      setProjectData(null);
      return () => {
        isMounted = false;
      };
    }

    import(`../../data/projectsData/${config.dataFile}`)
      .then((mod) => {
        if (!isMounted) return;
        setProjectData(mod && mod.default ? mod.default : mod);
      })
      .catch(() => {
        if (!isMounted) return;
        setProjectData(null);
      });

    return () => {
      isMounted = false;
    };
  }, [projectId]);

  useLayoutEffect(() => {
    scrollToTop();
  }, [projectId, scrollToTop]);


  useEffect(() => {
    const previous = typeof window !== 'undefined' && window.history && window.history.scrollRestoration;
    try {
      if (window.history && 'scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    } catch {}

    return () => {
      try {
        if (window.history && 'scrollRestoration' in window.history && previous) {
          window.history.scrollRestoration = previous;
        } else if (window.history && 'scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      } catch {}
    };
  }, []);

  useEffect(() => {
    scrollToTop();

    // Fallbacks to ensure scroll resets even if something paints at previous position
    const t0 = setTimeout(() => {
      scrollToTop();
    }, 0);
    const t1 = setTimeout(() => {
      scrollToTop();
    }, 50);


    return () => {
      clearTimeout(t0);
      clearTimeout(t1);

    };
  }, [projectId, projectData, scrollToTop]);

  const portfolioItems = [
    { id: 'research-paper-reaper-voice-optimization', category: 'video_game' },
    { id: 'advertising',youtubeUrls: [
      'https://www.youtube.com/embed/gE8VU-q4law', 'https://www.youtube.com/embed/Lk8t6WR8_h0', 'https://www.youtube.com/embed/vNxlJP_EsEg', 'https://www.youtube.com/embed/w0AzriPycLE', 'https://www.youtube.com/embed/0K7VCW0lvCE', 'https://www.youtube.com/embed/8rfdXTYwROs', 'https://www.youtube.com/embed/obKUHUpr_To', 'https://www.youtube.com/embed/nz4Qc6fIaOQ', 'https://www.youtube.com/embed/qmguZMfMG-w', 'https://www.youtube.com/embed/4PXKjOgiTwc', 'https://www.youtube.com/embed/kLpC6-uSOPM'
    ]},
    { id: 'coda', youtubeUrls:[ 'https://www.youtube.com/embed/SPo3tCna5qU']},
    { id: 'la-fievre', youtubeUrls:['https://www.youtube.com/embed/tzdKk4NS158']},
    { id: 'dubbing', image: MOB },
    { id: 'encounters', youtubeUrls:['https://www.youtube.com/embed/mA66Gmdh9Vg']},
    { id: 'ventorys-inn', youtubeUrls:['https://youtube.com/embed/2VIXfCmw2H4']},
    { id: 'helluva-boss-vf', youtubeUrls: ['https://www.youtube.com/embed/XxYX9RXt9NA']},
    { id: 'urusei-yatsura', image: LAMU_2},
    { id: 'outrunner', youtubeUrls:['https://youtube.com/embed/BDgu-jD4FBk']},
    { id: 'erreur-est-humaine', youtubeUrls:['https://youtube.com/embed/TrTJhVpGO9g']},
    { id: 'zap-from-beyond', youtubeUrls:['https://www.youtube.com/embed/qEObRhHvPNg']},
    { id: 'forlorn', youtubeUrls:['https://www.youtube.com/embed/dxVvgH_pgxo']},
    { id: 'a-new-machinist', youtubeUrls:['https://www.youtube.com/embed/Nd5FXsf38NI?si=GbB2VHYKf58lezac']},
    { id: 'yurei', youtubeUrls:['https://www.youtube.com/embed/FYOwYOIxVrk']}
    //{ id: 'flash-from-the-past', youtubeUrls: ['https://www.youtube.com/embed/SA3jeGLRXBo']},
    //{ id: 'summertime-in-teyvat', youtubeUrls:['https://www.youtube.com/embed/ijRvd6DQhuQ']},
    //{ id: 'bibliotech', youtubeUrls:['https://www.youtube.com/embed/y3Ej0R4iKKg']},
    //{ id: 'lucifarin-live', image: LUCIFARIN, youtubeUrls: ['https://www.youtube.com/embed/k3YIP7Y5_NM']},
    //{ id: 'sugar-rush', image: SUGARRUSH_1, additionalImages: [SUGARRUSH_2,SUGARRUSH_3,SUGARRUSH_4]},
    //{ id: 'big-little-feud', image: BIGLITTLEFEUD_1, additionalImages: [BIGLITTLEFEUD_2,BIGLITTLEFEUD_3,BIGLITTLEFEUD_4]},
    //{ id: 'the-fall', image: THEFALL1},
    //{ id: 'the-beetles', youtubeUrls: ['https://www.youtube.com/embed/7nbPCCdIap8'], image: BEETLES_1, additionalImages: [BEETLES_2,BEETLES_3]},
    //{ id: 'humanophobia', image: HUMANOPHOBIA_3, additionalImages: [HUMANOPHOBIA_1,HUMANOPHOBIA_2]},
  ].map(p => ({
    ...p,
    title: t(`projectDetails.${p.id}.title`),
    description: t(`projectDetails.${p.id}.description`),
    whatidid: t(`projectDetails.${p.id}.whatidid`)
    //,
    //category: t(`projectDetails.${p.id}.category`)
  }));

  const projectBase = portfolioItems.find(item => item.id === projectId);

  const getLocalizedValue = (value) => {
    if (!value) return value;
    if (typeof value === 'object' && !Array.isArray(value)) {
      return value[language] ?? value.fr ?? value.en;
    }
    return value;
  };

  const project = projectBase
    ? {
        ...projectBase,
        ...(projectData || {}),
        title: getLocalizedValue(projectData && projectData.title) || projectBase.title,
        description: getLocalizedValue(projectData && projectData.description) || projectBase.description,
        pitch: getLocalizedValue(projectData && projectData.pitch) || projectBase.pitch,
        whatidid: getLocalizedValue(projectData && projectData.whatidid) || projectBase.whatidid,
        team: (projectData && projectData.team) || projectBase.team,
      }
    : null;
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleImageIndex, setVisibleImageIndex] = useState(0);

  const handleBackClick = () => {
    setShowOverlay(true);
    navigate('/#portfolio', { replace: false });

    setTimeout(() => {
      setShowOverlay(false);
    }, 300);
  };

  const images = project ? [
    ...(project.youtubeUrls || []).map(url => ({ type: 'youtube', url })),
    ...(project.pdfUrl ? [{ type: 'pdf', url: project.pdfUrl }] : []),
    { type: 'image', url: project.image },
    ...(project.additionalImages || []).map(img => ({
      type: typeof img === 'string' && img.endsWith('.mp4') ? 'video' : 'image',
      url: img,
    })),
  ] : [];

  const filteredImages = images.filter(item => item.url && item.url !== '');
  useEffect(() => {
    if (!filteredImages || filteredImages.length === 0) return;
    const current = filteredImages[currentImageIndex];
    if (current && (current.type === 'youtube' || current.type === 'video')) {
    }
  }, [currentImageIndex, filteredImages]);

  if (!project) {
    return <h2>{t('projectDetails.notFound', 'Projet non trouvé')}</h2>;
  }

  const handlePrevClick = () => {
    setCurrentImageIndex(prevIndex => (prevIndex === 0 ? filteredImages.length - 1 : prevIndex - 1));
  };

  const handleNextClick = () => {
    setCurrentImageIndex(prevIndex => (prevIndex === filteredImages.length - 1 ? 0 : prevIndex + 1));
  };

  const handleItemClick = (index) => {
    setCurrentImageIndex(index);
    setVisibleImageIndex(index);
  };

  const navigateToProject = (direction) => {
    const currentIndex = portfolioItems.findIndex(item => item.id === projectId);
    let nextIndex;
    
    if (direction === 'next') {
      nextIndex = (currentIndex + 1) % portfolioItems.length;
    } else {
      nextIndex = (currentIndex - 1 + portfolioItems.length) % portfolioItems.length;
    }
    
    setShowOverlay(true);
    scrollToTop();
    navigate(`/project/${portfolioItems[nextIndex].id}`, { replace: false });
    
    setTimeout(() => {
      setShowOverlay(false);
    }, 300);
  };

  
  // Style normal pour les autres projets - NOUVELLE STRUCTURE
  return (
    <div className="project-details-new">
      {/* Left Navigation Bar */}
      <div className="left-nav-bar">
        <Link to="/" className="nav-item" title={t('nav.home', 'Home')}>
          Home
        </Link>
        <Link to="/#about" className="nav-item" title={t('nav.about', 'About')}>
          About
        </Link>
        <Link to="/#services" className="nav-item" title={t('nav.services', 'Services')}>
          Services
        </Link>
          <button className="nav-item_portfolio" onClick={handleBackClick}>
          {"Portfolio"}
        </button>
        <Link to="/#contact" className="nav-item" title={t('nav.contact', 'Contact')}>
          Contact
        </Link>
      </div>

      {/* Main Content Area */}
      <div className="project-content">
        {/* Title and Subtitle */}
        <div className="project-header-new">
          <h1 className="project-title-new">{project.title}</h1>
          <p className="project-subtitle-new" dangerouslySetInnerHTML={{ __html: project.description }} />
        </div>

        {/* Hero Section - Video/Image principale */}
        <div className="project-hero">
          <div className="hero-media">
            {filteredImages.length > 0 && filteredImages[0] && (
              <>
                {filteredImages[0].type === 'youtube' ? (
                  <iframe
                    className="hero-video"
                    width="100%"
                    height="500"
                    src={filteredImages[0].url}
                    title={project.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : filteredImages[0].type === 'video' ? (
                  <video className="hero-video" controls onPlay={() =>'function'}>
                    <source src={filteredImages[0].url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <LazyImage
                    className="hero-image"
                    src={filteredImages[0].url}
                    alt={project.title}
                  />
                )}
              </>
            )}
          </div>
        </div>

        {/* PDF Section - Only for research paper */}
        {project.id === 'research-paper-reaper-voice-optimization' && (
          <div className="pdf-section">
            <iframe
              className="project-pdf"
              src={`/Memoire_M1_BRUSCHI_Tanguy.pdf#view=FitH`}
            ></iframe>
          </div>
        )}

        {/* Single Column Layout for Research Paper, Advertising and Other Projects */}
        {(project.id === 'research-paper-reaper-voice-optimization' || 
          project.id === 'advertising' || 
          project.id === 'coda' || 
          project.id === 'la-fievre' || 
          project.id === 'dubbing' || 
          project.id === 'encounters' || 
          project.id === 'urusei-yatsura' || 
          project.id === 'helluva-boss-vf') ? (
          <div className="project-body-research">
            <div className="research-content-box">
              <div className="research-content">
                {Array.isArray(project.whatidid) ? (
                  <div className="research-section">
                    {project.whatidid.map((section, index) => (
                      <div key={index}>
                        {section && section.title ? <h3>{getLocalizedValue(section.title)}</h3> : null}
                        {section && section.content ? (
                          <p dangerouslySetInnerHTML={{ __html: getLocalizedValue(section.content) }} />
                        ) : null}
                      </div>
                    ))}
                  </div>
                ) : project.whatidid ? (
                  <div className="research-section" dangerouslySetInnerHTML={{ __html: getLocalizedValue(project.whatidid) }} />
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          /* Two Column Layout for other projects */
          <div className="project-body">
            {/* Left Column - Pitch */}
            <div className="project-left">
              <div className="pitch-box">
                {/*<h2>{t('projectDetails.pitch', 'Pitch')}</h2> */}
                <p
                  className="pitch-description"
                  dangerouslySetInnerHTML={{ __html: project.pitch || project.description }}
                />
              </div>
            </div>

            {/* Right Column - Challenges/My Work and Media Gallery */}
            <div className="project-right">
              <div className="challenges-box">
                <h2>Challenges</h2>
                {Array.isArray(project.whatidid) ? (
                  <div className="challenges-content">
                    {project.whatidid.map((section, index) => (
                      <div key={index}>
                        {section && section.title ? <h3>{getLocalizedValue(section.title)}</h3> : null}
                        {section && section.content ? (
                          <p dangerouslySetInnerHTML={{ __html: getLocalizedValue(section.content) }} />
                        ) : null}
                      </div>
                    ))}
                  </div>
                ) : project.whatidid ? (
                  <div className="challenges-content" dangerouslySetInnerHTML={{ __html: project.whatidid }} />
                ) : null}
              </div>
            </div>
          </div>
        )}

{/*             {filteredImages.length > 1 && (
              <div className="gallery-section">
                <h3>{t('projectDetails.gallery', 'Gallery')}</h3>
                <div className="image-grid">
                  {filteredImages.slice(1).map((item, index) => (
                    <div
                      key={index}
                      className="gallery-item"
                      onClick={() => handleItemClick(index + 1)}
                    >
                      {item.type === 'video' ? (
                        <video className="gallery-thumbnail">
                          <source src={item.url} type="video/mp4" />
                        </video>
                      ) : item.type === 'youtube' ? (
                        <div className="youtube-thumb">
                          <LazyImage
                            src={`https://img.youtube.com/vi/${item.url.split('/').pop()}/hqdefault.jpg`}
                            alt={`YouTube Thumbnail ${index + 1}`}
                          />
                        </div>
                      ) : (
                        <LazyImage src={item.url} alt={`Gallery ${index + 1}`} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )} */}

{/*         {project.software && project.software.length > 0 && (
          <div className="skills-section">
            <h2>{t('projectDetails.skills', 'Skills')}</h2>
            <div className="skills-grid">
              {project.software.map((sw, index) => (
                <div key={index} className="skill-badge">
                  <LazyImage src={sw.logo} alt={sw.name} />
                  <span>{sw.name}</span>
                </div>
              ))}
            </div>
          </div>
        )} */}
        {project.team && project.team.length > 0 && project.id !== 'research-paper-reaper-voice-optimization' ? (
          <div className="team-section">
           {/* <h2>{t('projectDetails.team', 'Team')}</h2> */}
            <div className="team-list">
              {project.team.map((member, index) => (
                <div key={index} className={
                      `team-member${
                        member && member.name &&
                        member.name.toString().toLowerCase().includes('tanguy') &&
                        member.name.toString().toLowerCase().includes('bruschi')
                          ? ' team-member-me'
                          : ''
                      }`
                    }>
                  <span
                    className={
                      `member-name${
                        member && member.name &&
                        member.name.toString().toLowerCase().includes('tanguy') &&
                        member.name.toString().toLowerCase().includes('bruschi')
                          ? ' member-name-me'
                          : ''
                      }`
                    }
                  >
                    {member.name}
                  </span>
                  <span className="member-role">{member.role}</span>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        {/* Navigation */}
        <div className="project-navigation">
          <button className="nav-button prev-button" onClick={() => navigateToProject('prev')}>
            <span className="nav-arrow" aria-hidden="true">←</span>
            {t('projectDetails.previousProject', 'Previous project')}
          </button>
          <button className="nav-button next-button" onClick={() => navigateToProject('next')}>
            {t('projectDetails.nextProject', 'Next project')}
            <span className="nav-arrow" aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;